import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { startThemeWatcher } from "./lib/theme";
import "./index.css";

// index.html resolves the mode before first paint; this keeps it honest for the
// rest of the session — re-checking the clock on the hour and on tab refocus.
startThemeWatcher();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
